import { slavicPluralize } from "../js/util/SlavicPluralize";
window.locale = "ru";
window.strings = {
    toLang: "В ",
    convertTextToLang: "Конвертировать выделенный текст в ",
    showKeyboard: "показать клавиатуру",
    hideKeyboard: "скрыть клавиатуру",
    showAbout: "показать о нас",
    hideAbout: "скрыть о нас",
    min: "мин",
    sec: "сек",
    readingTime: "время чтения",
    speakingTime: "время говорения",
    languages: {
        ru: "Русский",
        uk: "Украинский",
        be: "Белоруский",
        bg: "Болгарский",
        de: "Немецкий",
        fr: "Французкий",
        es: "Испанский",
        pt: "Португальский",
        it: "Итальянский",
        tr: "Турецкий",
        "da/no": "Дано-норвежский",
        sv: "Шведский",
        fi: "Финский",
        cs: "Чешский",
        nl: "Нидерландский",
        pl: "Польский",
        hu: "Венгерский",
        ro: "Румунский",
        mi: "Маори",
        fo: "Фарерский",
        ic: "Исландский",
        el: "Греческий",
        ka: "Грузинский"
    },
    feedbackThanks: "Спасибо за ваш отзыв",
    counters: {
        getCharacterPlural(count) {
            return slavicPluralize(count, "символ", "символа", "символов");
        },
        getWordPlural(count) {
            return slavicPluralize(count, "слово", "слова", "слов");
        }
    }
};
